import { Component } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ConstantContactCampaignListItem } from '../constant-contact-campaign-list-item';

@Component({
  selector: 'app-constant-contact',
  templateUrl: './constant-contact.component.html',
  styleUrls: ['./constant-contact.component.css']
})
export class ConstantContactComponent {

  campaigns: ConstantContactCampaignListItem[] = [];

  constructor(
    private httpService: HttpService
  ){
    httpService.getAllConstantContactCampaigns().subscribe(res => {
      console.log(res);
      this.campaigns = res;
    });
  }

}
